import React, { Fragment } from 'react';

import TermsAccordion from './TermsAccordion';

const TERMS_TITLE_LIST = [
  'Conditions of Sale*',
  'Shipping*',
  'Contract(s)',
  'Payment(s)',
  'Taxes',
  'Condition(s)'
];

const TermsAndConditions = ({ handleTermsCheckbox, handleTermsInput, terms, toggleAccordion }) => (
  <Fragment>
    <h3 className="mt-5">Terms &amp; Conditions of Sale to be Displayed</h3>
    <p>
      Provide comprehensive set of terms and conditions so buyers clearly understand the sale
      condition statements, shipping policy, accepted forms of payments, and other important
      information about your business.
    </p>
    <p className="font-weight-bold">
      Do not enter HTML tags, hyperlinks, styles, javascript, or non-Western European languages.
    </p>

    {terms
      && terms.map((term, index) => (
        <TermsAccordion
          handleTermsCheckbox={handleTermsCheckbox}
          handleTermsInput={handleTermsInput}
          index={index}
          isRequired={index === 0 || index === 1}
          isLast={index === terms.length - 1}
          key={term.id}
          toggleAccordion={toggleAccordion}
          term={term}
          title={TERMS_TITLE_LIST[index]}
        />
      ))}
  </Fragment>
);

export default TermsAndConditions;
